<template>
  <!-- 登录 -->
  <div
    class="box"
    style="min-width: 1600px;"
  >
    <NavBar navIndex="4" :imgHeight="482"></NavBar>
    <!-- <div style="padding:30px;"></div> -->
    <div style="position:relative;width: 100%;">
      <img
        style="width: 100%;"
        src="../assets/teacher/teacher-bg.png"
        alt=""
        class="mod-section-ad"
      >

      <div class="animate__animated animate__mian slogan">
        <div class="slogan-title">优选师资</div>
        <div class="slogan-subtitle">
          专研一门学科，专注学生成长
        </div>
      </div>
    </div>

    <div>

      <div
        v-for="(item,index) in teacherData"
        :key="index"
        class="teacher-big-box"
      >
        <div>
          <div class="teacher-classify">
            {{item.tagName}}
            <div class="teacher-classify-border"></div>
          </div>

          <div class="teacher-classify-text">
            {{item.tagDesc}}
          </div>
        </div>

        <div class="teacher-box">

          <el-carousel
            :autoplay="false"
            height="320px"
            style="width: 100%;"
          >
            <el-carousel-item
              v-for="(item_c,index_c) in item.slideshow"
              :key="index_c"
              style="width: 100%;"
            >

              <div style="display: flex;align-items: center;width: 100%;padding: 20px 50px;box-sizing: border-box;">

                <div
                  v-for="(item_z,index_z) in item_c"
                  :key="index_z"
                  class="teacher"
                >
                  <img
                    style="width: 100%;height:100%;"
                    :src="item_z.teacherPic"
                    alt=""
                    class="scaleImg_hover br-r6"
                  >
                  <!-- <el-image v-else style="width: 100%;height:100%;" :src="item_z.teacherPic" lazy></el-image> -->
                  <div class="teacher-name-box">
                    <img
                      class="teacher-name-bg"
                      src="../assets/name-bg.png"
                      alt=""
                    >
                    <div class="teacher-name">{{item_z.teacherName}}</div>
                  </div>
                  <div class="teacher-introduce">{{item_z.teacherExperience}}</div>
                </div>
              </div>

            </el-carousel-item>
            <!-- <el-carousel-item>111</el-carousel-item>
                    <el-carousel-item>2</el-carousel-item>
                    <el-carousel-item>13331</el-carousel-item> -->
          </el-carousel>

        </div>
      </div>

      <!-- <div class="teacher-big-box">
            <div style="width: 40%;">
                <div class="teacher-classify" >
                    弘知物理
                    <div class="teacher-classify-border" ></div>
                </div>

                <div class="teacher-classify-text" >
                    队成员由工科博士领衔，大多毕业于武汉大学、华中科技大学、中南大学等一流高校，且教学经验丰富。对初高中各类物理知识与考试有透彻的研究，对不同层次学生有精确匹配的教学方案。教学理念先进，方法高效，尤其擅长尖子生培养。众多学员在各大名校持续名列前茅。
                </div>
            </div>
            
            <div class="teacher-box">
                <div class="teacher">
                    <img style="width: 100%;height:100%;" src="../assets/man-demo.png" alt="">
                    <div class="teacher-name-box">
                      <img class="teacher-name-bg" src="../assets/name-bg.png" alt="">
                      <div class="teacher-name" >易大</div>
                    </div>
                </div>

                <div class="teacher">
                    <img style="width: 100%;height:100%;" src="../assets/man-demo.png" alt="">
                    <div class="teacher-name-box">
                      <img class="teacher-name-bg" src="../assets/name-bg.png" alt="">
                      <div class="teacher-name" >易大</div>
                    </div>
                </div>

                <div class="teacher">
                    <img style="width: 100%;height:100%;" src="../assets/man-demo.png" alt="">
                    <div class="teacher-name-box">
                      <img class="teacher-name-bg" src="../assets/name-bg.png" alt="">
                      <div class="teacher-name" >易大</div>
                    </div>
                </div>

                <div class="teacher">
                    <img style="width: 100%;height:100%;" src="../assets/man-demo.png" alt="">
                    <div class="teacher-name-box">
                      <img class="teacher-name-bg" src="../assets/name-bg.png" alt="">
                      <div class="teacher-name" >易大</div>
                    </div>
                </div>

                <div class="teacher">
                    <img style="width: 100%;height:100%;" src="../assets/man-demo.png" alt="">
                    <div class="teacher-name-box">
                      <img class="teacher-name-bg" src="../assets/name-bg.png" alt="">
                      <div class="teacher-name" >易大</div>
                    </div>
                </div>

                <div class="teacher">
                    <img style="width: 100%;height:100%;" src="../assets/man-demo.png" alt="">
                    <div class="teacher-name-box">
                      <img class="teacher-name-bg" src="../assets/name-bg.png" alt="">
                      <div class="teacher-name" >易大</div>
                    </div>
                </div>

            </div>
        </div> -->

    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from "@/components/navBar.vue";
import Footer from "@/components/Footer.vue";
import { homeTeacher } from "@/request/api";

export default {
  name: "teacher",
  components: {
    NavBar,
    Footer,
  },
  data() {
    return {
      teacherData: [],
    };
  },
  mounted() {
    let that = this;

    homeTeacher().then((res) => {
      let data = res.data.data;

      function spArr(arr, num) {
        //arr是你要分割的数组，num是以几个为一组
        let newArr = []; //首先创建一个新的空数组。用来存放分割好的数组
        for (let i = 0; i < arr.length; ) {
          //注意：这里与for循环不太一样的是，没有i++
          newArr.push(arr.slice(i, (i += num)));
        }
        return newArr;
      }

      data.forEach(function (res) {
        res.slideshow = spArr(res.children, 5);
      });

      that.teacherData = data;
    });
  },
  methods: {},
};
</script>

<style scoped>
.content-title-border {
  position: absolute;
  width: 32px;
  height: 4px;
  background-color: #fff;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15%;
}
.teacher-big-box {
  width: 1200px;
  /* display: flex; */
  margin: 50px auto 100px;
}
.teacher-classify {
  position: relative;
  font-size: 26px;
  font-family: 'PingFang-Bold';
  width: 70%;
  margin-bottom: 25px;
}
.teacher-classify-border {
  position: absolute;
  width: 32px;
  height: 2px;
  background-color: #0050a7;
  bottom: -25%;
}
.teacher-classify-text {
  /* padding-right: 40px; */
  box-sizing: border-box;
  line-height: 30px;
}
.teacher-box {
  width: 1200px;
  display: flex;
  flex-wrap: wrap;
  /* padding-left: 30px; */
  box-sizing: border-box;
}
.teacher {
  position: relative;
  /* margin-right: 20px; */
  width: 180px;
  height: 230px;
  /* margin-bottom: 20px; */
  margin: 15px;
}
.teacher-name {
  position: absolute;
  left: 45%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
}
.teacher-name-bg {
  display: block;
  width: 90px;
  height: 20px;
}
.teacher-name-box {
  position: absolute;
  left: 0;
  bottom: 0;
}
.teacher-introduce {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: rgba(256, 256, 256, 0.3);
  font-size: 14px;
  line-height: 23px;
  box-sizing: border-box;
  overflow: hidden;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
}
</style>
    